// Wave 1 safety (docs/product/spec-safety.md "Web"): under an uploaded picture (the upload sheet's row, a library
// item's Details), a small note when the picture screen saw a real person (the consent box, POST
// /api/library/:id/consent) or a child / well-known person (it can't be a reference at all). Nothing otherwise.
import { useState } from "react";
import { api } from "../api";
import { bump } from "../store";
import { SAFETY_COPY, safetyNotice } from "../safety";
import type { Asset } from "../types";

export function SafetyNotice({ asset, onChange }: { asset: Asset; onChange?: (a: Asset) => void }) {
  const kind = safetyNotice(asset.meta);
  const [ticked, setTicked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  if (done)
    return (
      <p className="safety-note is-done" role="status">
        {SAFETY_COPY.consented}
      </p>
    );
  if (kind === "ref-blocked") return <p className="safety-note is-blocked">{SAFETY_COPY.refBlocked}</p>;
  if (kind !== "needs-consent") return null;

  const confirm = async () => {
    if (!ticked || busy) return;
    setBusy(true);
    setError(null);
    try {
      const a = await api.consentLibrary(asset.id);
      setDone(true);
      onChange?.(a);
      bump("library");
    } catch (e) {
      setError((e as Error).message || "That didn't save. Try again.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="safety-note is-consent">
      <p>{SAFETY_COPY.needsConsent}</p>
      <label className="safety-check">
        <input type="checkbox" checked={ticked} onChange={(e) => setTicked(e.target.checked)} />
        <span>{SAFETY_COPY.consentBox}</span>
      </label>
      {error && (
        <p className="safety-err" role="alert">
          {error}
        </p>
      )}
      <button type="button" className="btn btn-quiet btn-small" data-action="library.consent" disabled={!ticked || busy} onClick={() => void confirm()}>
        {busy ? "Saving…" : "Confirm"}
      </button>
    </div>
  );
}
